/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable array-callback-return */
/* eslint-disable no-case-declarations */
import React, { useState, useEffect } from 'react';
import { message, Button, Upload, Modal, Spin } from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { pdf } from '@react-pdf/renderer';
import moment from 'moment';

import { DataService } from '../../../config/dataService/dataService';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main } from '../../styled';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { CompanyCertificate, EmpCardPrint, ImagePreview, TrainignCertificate } from '../../common';
import { API_ENDPOINT } from '../../../config/config';

const CARD_TITLES = [
  {
    id: 1,
    title: 'Chairman'
  },
  {
    id: 2,
    title: 'Secretary General'
  },
  {
    id: 3,
    title: 'Principal'
  },
  {
    id: 4,
    title: 'CARD Issuing Authority'
  },
];

const SIGNATURES = {
  "ChAIRMAIN": 1,
  "SECRETARY_GENERAL": 2,
  "PRINCIPAL": 3,
  "CARD_ISSUANCE": 4
}

const RESOLUTION_WIDTH = 600;
const RESOLUTION_HEIGHT = 300;

function SignatureCards() {
  const [cardImages, setCardImages] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [loadingStates, setLoadingStates] = useState({}); // Tracks loading state per card

  const fetchImages = async () => {
    try {
      const response = await DataService.post('/signature-images/query');
      const respData = response.data;
      if (Boolean(respData.status)) {
        if (Array.isArray(respData.data) && Array(respData.data).length > 0) {
          const tempCardImages = {}
          respData.data.map(item => {
            tempCardImages[item.signature_type_id] = `${API_ENDPOINT}/${item.image_path}`
          })

          setCardImages(tempCardImages);
        }

      } else {
        message.error('Failed to fetch signature images.');
      }
    } catch (error) {
      message.error(`Error fetching images: ${error.message}`);
    }
  };

  const handlePreview = (image) => {
    setPreviewImage(image);
    setPreviewVisible(true);
  };

  const handleUpload = async (file, itemID) => {
    try {
      // Ensure only images are uploaded
      if (!file.type.startsWith('image/')) {
        message.error('Only image files are allowed.');
        return;
      }

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = async () => {
        if (img.width !== RESOLUTION_WIDTH || img.height !== RESOLUTION_HEIGHT) {
          message.error(`Image must be ${RESOLUTION_WIDTH} x ${RESOLUTION_HEIGHT} resolution.`);
          return;
        }

        setLoadingStates((prevState) => ({ ...prevState, [itemID]: true }));

        const formData = new FormData();
        formData.append('image', file);
        formData.append('signature_type_id', Number(itemID));

        try {
          const response = await DataService.post('/signature-images/create-update', formData);
          if (response.data.status) {
            message.success('Image uploaded successfully!');
            fetchImages(); // Refresh images after successful upload
          } else {
            message.error(`Failed to upload image. ${response.data.message}`);
          }
        } catch (error) {
          message.error(`Error uploading image: ${error.message}`);
        }
        setLoadingStates((prevState) => ({ ...prevState, [itemID]: false }));
      };
    } catch (error) {
      message.error(`Error uploading image: ${error.message}`);
    } finally {
      setLoadingStates((prevState) => ({ ...prevState, [itemID]: false }));
    }
  };

  const handleSampleDownload = async (itemID) => {
    try {
      setLoadingStates((prevState) => ({ ...prevState, [itemID]: true }));
      switch (itemID) {
        case SIGNATURES.ChAIRMAIN:
        case SIGNATURES.SECRETARY_GENERAL:
          {
            const blob = await pdf(
              <CompanyCertificate
                certificateNumber={1001}
                companyName='TESLA HYPER LOOP inc, Private LIMITED'
                sigChairman={cardImages[SIGNATURES.ChAIRMAIN]}
                sigSecGeneral={cardImages[SIGNATURES.SECRETARY_GENERAL]}
                qrImage={require('../../../static/img/apsaa_logo.png')}
                forYear={moment().get('year')}
              />
            ).toBlob();

            // Trigger download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `company_certificate_${moment().format('DMMYYYY_hh:mm_a')}.pdf`;
            link.click();
          }
          break;
        case SIGNATURES.PRINCIPAL:
          {
            const blob = await pdf(
              <TrainignCertificate
                certificateNumber={1001}
                sigPrincipal={cardImages[SIGNATURES.PRINCIPAL]}
              // qrImage={require('../../../static/img/apsaa_logo.png')}
              />
            ).toBlob();

            // Trigger download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `training_certificate_${moment().format('DMMYYYY_hh:mm_a')}.pdf`;
            link.click();
          }
          break;
        case SIGNATURES.CARD_ISSUANCE:
          {
            const blob = await pdf(
              <EmpCardPrint
                issuanceAuthority={cardImages[SIGNATURES.CARD_ISSUANCE]}
              // qrImage={require('../../../static/img/apsaa_logo.png')}
              />
            ).toBlob();

            // Trigger download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `e_card_${moment().format('DMMYYYY_hh:mm_a')}.pdf`;
            link.click();
          }
          break;

        default:
          break;
      }
      setLoadingStates((prevState) => ({ ...prevState, [itemID]: false }));
    } catch (error) {
      message.error(`Error download sample: ${error.message}`);
    } finally {
      setLoadingStates((prevState) => ({ ...prevState, [itemID]: false }));
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Signature Cards" routes={[]} />
      <Main>
        <div className="grid grid-cols-2 gap-4">
          {CARD_TITLES.map((item) => (
            <Cards key={item.id} title={item.title} size="default">
              <div className="flex flex-col items-center">
                {loadingStates[item.id] ? (
                  <Spin size="large" />
                ) : cardImages[item.id] ? (
                  <img
                    src={cardImages[item.id]}
                    alt={`${item.title} Signature`}
                    className="w-48 h-24 object-contain cursor-pointer"
                    onClick={() => handlePreview(cardImages[item.id])}
                  />
                ) : (
                  <div className="w-48 h-24 border flex items-center justify-center">
                    <span className="text-red-500">No image</span>
                  </div>
                )}
                <span className='text-[10px] !text-yellow-700'>upload an image of exact 600x300 resolution </span>
                <div className="flex space-x-4 mt-4">
                  <Upload
                    beforeUpload={(file) => {
                      handleUpload(file, item.id);
                      return false;
                    }}
                    showUploadList={false}
                  >
                    <Button disabled={loadingStates[item.id] || false} icon={<UploadOutlined />}>Upload Image</Button>
                  </Upload>
                  <Button type="primary" disabled={loadingStates[item.id] || false} icon={<PlusOutlined />} onClick={() => handleSampleDownload(item.id)}>
                    Sample PDF
                  </Button>
                </div>
              </div>
            </Cards>
          ))}
        </div>

        <ImagePreview
          imageSrc={previewImage}
          onClose={() => { setPreviewVisible(false); setPreviewImage(null) }}
          visible={previewVisible}
        />
      </Main>
    </>
  );
}

export default SignatureCards;
